<app-pickup-table-filter></app-pickup-table-filter>

<div class="content-spacer">
    <app-pickup-table></app-pickup-table>
</div>
